// @ts-nocheck
/* eslint-disable */

import { TActiveContent } from "./ribbon/interfaces";
import { addActiveContent, removeActiveContent } from "./state/ribbon/state";
import { store } from "./state/store";

/**
 * Zakladni objekt, ze ktereho dedi vsechny "contenty" praveho sloupce.
 * Jeden ci vice contentu muze byt aktivnich (.isActive()); tyto jsou evidovany
 * v poli "Mapy.active". Vychozi chovani contentu behem aktivace je deaktivovat vsechny predchozi.
 */
export default class Content {
	_scrollTop: number;

	_dom: {
		[key: string]: any;
	};

	_contentName: TActiveContent;

	constructor() {
		this._scrollTop = 0;
		this._dom = {};
		this._contentName = "";
	}

	// eslint-disable-next-line class-methods-use-this
	destroy() {}

	/**
	 * Uzivatel ted ma tento content videt. Zejmena to znamena, ze az na vyjimky (viz Content.Overlay) se musi deaktivovat vsechny predchozi contenty.
	 */
	activate() {
		if (this.isActive()) {
			return this;
		}

		/* zrusit predchozi */
		this._deactivatePrevious();

		/* pripnout se */
		const parent = Mapy.getComponent("layout").getBody();

		parent.appendChild(this._dom.container);

		/* pridat se do seznamu aktivnich */
		Mapy.active.unshift(this);

		if (this._contentName) {
			store.dispatch(addActiveContent(this._contentName));
		}

		/* zaridit viditelnost v pravem sloupci */
		return this.show();
	}

	/**
	 * Tento content ted jde pryc. Neznamena to, ze se cisti, ale ze nema byt videt (bude nahrazen nekym jinym).
	 */
	deactivate() {
		if (!this.isActive()) {
			return this;
		}

		/* pryc ze sloupce */
		this._dom.container.remove();

		/* pryc ze seznamu aktivnich komponent */
		const index = Mapy.active.indexOf(this);

		Mapy.active.splice(index, 1);

		if (this._contentName) {
			store.dispatch(removeActiveContent(this._contentName));
		}

		return this;
	}

	isActive() {
		return Mapy.active.indexOf(this) > -1;
	}

	/**
	 * Metoda volana mj. v ramci aktivace. Je zodpovedna za viditelnost obsahu contentu ve sloupci + jeho rekonfiguraci (hlavicka, paticka).
	 */
	show() {
		this._dom.container.style.display = "";
		requestAnimationFrame(() => {
			Mapy.getComponent("layout").getScrollNode().scrollTop = this._scrollTop;
		});

		return this;
	}

	/**
	 * Tohle na nas vola nekdo, kdo nas chce prekryt. Zustavame tedy aktivni a jen nemame byt chvilku ve sloupci videt.
	 */
	hide() {
		this._scrollTop = Mapy.getComponent("layout").getScrollNode().scrollTop;
		this._dom.container.style.display = "none";

		return this;
	}

	/**
	 * Serializovatelny stav (do historie, oblibenych...)
	 */
	// eslint-disable-next-line class-methods-use-this
	getState() {
		return {};
	}

	/**
	 * Obnoveni stavu z historie, oblibenych...
	 */
	// eslint-disable-next-line @typescript-eslint/no-unused-vars, class-methods-use-this
	setState(state) {
	}

	/**
	 * Vraci objekt s nody, ktere se maji pouzit pro tisk
	 */
	// eslint-disable-next-line class-methods-use-this
	getPrintNodes() {
		return {
			title: undefined,
			panel: undefined,
		};
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars, class-methods-use-this
	historyAfterState(state) {
	}

	// eslint-disable-next-line class-methods-use-this
	_deactivatePrevious() {
		while (Mapy.active.length) {
			Mapy.active[0].deactivate();
		}

		Mapy.getComponent("dimcurator").removeError();
	}
}
